// Stub for next-themes compatibility
// In a SPA, theme is managed entirely client-side via localStorage

export function useTheme() {
  return {
    theme: 'dark',
    setTheme: (theme: string) => {
      document.documentElement.classList.remove('light', 'dark');
      document.documentElement.classList.add(theme);
      localStorage.setItem('vite-ui-theme', theme);
    },
    systemTheme: 'dark',
    themes: ['light', 'dark'],
  };
}
